// extracted by mini-css-extract-plugin
export var logo = "_bh-2";
export var logoWrapper = "_bh-1";
export var strip = "_bh-0";